import axios from 'axios';

export const Request = axios.create({
  baseURL: process.env.VUE_APP_TINABA_API_BASE || 'https://api.valid.tinaba.it/api/usr/v2/',
})

export const RequestBus = axios.create({
  baseURL: process.env.VUE_APP_TINABA_API_BASE?.replace('usr', 'bus') || 'https://api.valid.tinaba.it/api/bus/v2/',
})

export const RequestBase = axios.create({
  baseURL: process.env.VUE_APP_TINABA_API_BASE?.replace('usr', '') || 'https://api.valid.tinaba.it/api/v2/',
})

export function fetchLinkToPay (id: number) {
  return Request.get(`/link-to-pay/pending/${id}`)
}

export function createAlipayCheckout (requestPaymentId: number) {
  return RequestBus.post(`alipay-connect/merchant-checkout/start`, { requestPaymentId })
}

export function createPaypalCheckout (requestPaymentId: number, paymentMethod: string) {
  return RequestBus.post(`paypal/checkout/start`, { requestPaymentId, paymentMethod })
}

export function confirmPaypalCheckout (payload = {}) {
  return RequestBus.post(`paypal/payments/business/complete`, payload)
}

export function fetchErrorMessages (locale = 'it') {
  return RequestBase.get(`errors/messages?locale=${locale}`)
}

export function fetchPaypalData (businessId: number) {
  return RequestBus.get(`paypal/businesses/${businessId}/payment-button/data`)
}